(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".accordion--single").forEach(function (accordion) {
      accordion.querySelectorAll("details").forEach(function (detail) {
        detail.addEventListener("toggle", function () {
          if (detail.open) {
            accordion.querySelectorAll("details").forEach(function (otherDetail) {
              if (otherDetail !== detail) {
                otherDetail.removeAttribute("open");
              }
            });
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
